import { Pipe, PipeTransform } from '@angular/core';
import {GradoDifficolta} from '../models';

@Pipe({
 name: 'difficolta'
})

export class DifficoltaPipe implements PipeTransform {
    /**
     * in base alla difficoltà ricevuta tramite parametro, uscirà un icona con la difficoltà designata
     * @param  {any[]} value
     * @returns px
     */
    transform(value: any[]): string {
        let difficolta: string;
        if (value != null) {
            if (value[0] != null) {
                switch (value[0].name)
                {
                    case "Non conosciuto":
                        difficolta = "<img src='./assets/img/ICONA_DIFFICOLTA_T.png' title='Difficolta non conosciuta' style='width:20px;height:20px'>";
                        break;
                    case "FACILE":
                        difficolta = "<img src='./assets/img/ICONA_DIFFICOLTA_T.png' title='Facile' style='width:20px;height:20px'>";
                        break;

                    case "MEDIA DIFFICOLTA":
                        difficolta = "<img src='./assets/img/ICONA_DIFFICOLTA_E.png' title='Media' style='width:20px;height:20px'>";
                        break;

                    case "DIFFICILE":
                        difficolta = "<img src='./assets/img/ICONA_DIFFICOLTA_EE.png' title='Media' style='width:20px;height:20px'>";
                        break;
        
                    default:
                        difficolta = "<img src='./assets/img/ICONA_DIFFICOLTA_T.png' title='Facile' style='width:20px;height:20px'>";
                }
            }
        }
        return difficolta;
    }

}
